import { useMemo, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import CloseIconSvg from 'public/icons/close.svg';

import { Button } from '../_Button/Button';

import styles from './Pill.module.css';

type PillProps = {
	option: string;
	filterName: string;
};

export function Pill(props: PillProps): JSX.Element {
	const { setValue, getValues } = useFormContext();

	const pill = useRef<HTMLDivElement>(null);

	const optionTitle = useMemo(() => {
		return props.option.replaceAll('-', ' ').split('_')[0];
	}, [props.option]);

	const clickHandler = () => {
		let currentOptions = getValues(props.filterName);

		if (!currentOptions) {
			return;
		}

		if (typeof currentOptions === 'string') {
			currentOptions = [currentOptions];
		}

		currentOptions = currentOptions.filter((x: string) => x !== props.option);

		setValue(props.filterName, currentOptions);
	};

	return (
		<div className={styles.pill} ref={pill}>
			{optionTitle}
			<Button title="Pill Close" className={styles.button} onClick={clickHandler}>
				<CloseIconSvg className={styles.icon} />
			</Button>
		</div>
	);
}
